import { render } from "./professionCreate.vue?vue&type=template&id=bede4a86&scoped=true"
import script from "./professionCreate.vue?vue&type=script&lang=js"
export * from "./professionCreate.vue?vue&type=script&lang=js"

import "./professionCreate.vue?vue&type=style&index=0&id=bede4a86&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bede4a86"]])

export default __exports__